module.exports = __webpack_public_path__ + "img/ally-rogo-black3.efa62def.png";